import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Avenir Next', sans-serif;
    -webkit-font-smoothing: antialiased;

    button,
    input,
    optgroup,
    select,
    textarea {
      font-family: 'Avenir Next', sans-serif;
    }
  }
`
export default GlobalStyle
